import React from 'react';
import PropTypes from 'prop-types';
import Provider from 'react-redux/es/components/Provider';
import ReactOnRails from 'react-on-rails';
import ListViewRightPart from '../../containers/ListViewRightPart/ListViewRightPart';
import MainLayout from '../../containers/MainLayout/MainLayout';
import BreadCrumbs from '../../containers/BreadCrumbs/BreadCrumbs';
import CityLeftPartComponent from '../../containers/CityLeftPartComponent/CityLeftPartComponent';
import MainSearch from '../../containers/MainSearch/MainSearch';

const CityComponent = (props) => {
  const appStore = ReactOnRails.getStore('appStore');

  const {
    title,
    descTeaser,
    descBody,
    pagesCount,
    mapUrlLv
  } = props;

  return (
    <div>
      <Provider store={appStore}>
        <MainLayout footerData={props.footerData}>
          <div className="grey-background">
            <div className="container">
              <div className="row">
                <div className="col-md-12">
                  <BreadCrumbs />
                </div>
              </div>
              <div className="row stretch">
                <div className="col-md-9">
                  <CityLeftPartComponent
                    title={title}
                    descTeaser={descTeaser}
                    descBody={descBody}
                    pagesCount={pagesCount}
                    mapUrlLv={mapUrlLv}
                  />
                </div>

                <div className="col-md-3">
                  <div className="rightContainer">
                    <ListViewRightPart />
                  </div>
                </div>
              </div>
              <MainSearch />
            </div>

          </div>
        </MainLayout>
      </Provider>
    </div>
  );
};

CityComponent.propTypes = {
  footerData: PropTypes.oneOfType([PropTypes.object]),
  title: PropTypes.string,
  descTeaser: PropTypes.string,
  descBody: PropTypes.string,
  pagesCount: PropTypes.number,
};

CityComponent.defaultProps = {
  footerData: {},
  title: '',
  descTeaser: '',
  descBody: '',
  pagesCount: 0,
};

export default CityComponent;
